import React from "react";
import { Link } from "react-router-dom";
import WorkWithUs from "../../../images/landing/work-with-us.png";
import "./style.css";
import localeText from "../../../../locale";

const cards = [
  { icon: "pi pi-users", title: "lp2PromotorCard1Title", description: "lp2PromotorCard1Desc", position: "card-top-left" },
  { icon: "pi pi-shop", title: "lp2PromotorCard2Title", description: "lp2PromotorCard2Desc", position: "card-top-right" },
  { icon: "pi pi-sync", title: "lp2PromotorCard3Title", description: "lp2PromotorCard3Desc", position: "card-bottom-left" },
  { icon: "pi pi-euro", title: "lp2PromotorCard4Title", description: "lp2PromotorCard4Desc", position: "card-bottom-right" },
];

const LandingWorkWithUs = () => {
  return (
    <section
      className="pt-6 md:py-8 full-width relative overflow-hidden"
      style={{ backgroundColor: "#2C6B47" }}
      id="promotor"
    >
      <div className="grid align-items-center ">
        <div className="col-12 md:col-6 flex flex-column gap-6">
          <div style={{ color: "#FFFFFF" }}>
            <div className="flex flex-column gap-3">
              <div className="flex align-items-center gap-2">
                <span style={{ width: "28px", height: "1px", backgroundColor: "#F4C542" }}></span>
                <span
                  className="eyebrow-text"
                  style={{ color: "#F4C542", letterSpacing: "0.12em" }}
                >
                  {localeText("lp2PromotorEyebrow")}
                </span>
              </div>

              <div
                className="font-bold text-4xl md:text-5xl line-height-2 title"
                style={{ color: "#F4C542" }}
              >
                {localeText("lp2PromotorTitle")}
              </div>
            </div>
          </div>
          <div className="font-regular text-lg" style={{ color: "#A9E4C4" }}>
            {localeText("lp2PromotorDescription")}
          </div>
          <div
            className="flex gap-3 p-3 border-round-lg"
            style={{
              border: "1px solid rgba(255,255,255,0.15)",
              backgroundColor: "rgba(255,255,255,0.06)",
            }}
          >
            <i className="pi pi-info-circle mt-1" style={{ color: "var(--extra-mint)" }}></i>
            <div className="text-sm" style={{ color: "rgba(255,255,255,0.75)" }}>
              {localeText("lp2PromotorInfoBox")}
            </div>
          </div>
          <div>
            <Link
              className="font-bold text-sm inline-flex align-items-center gap-2 border-round-md px-5 py-3 no-underline"
              style={{ backgroundColor: "#fff", color: "#2C6B47" }}
              to="/promoter"
            >
              {localeText("doYouWantToWork")}
              <i className="pi pi-arrow-right text-xs"></i>
            </Link>
          </div>
        </div>
        <div className="col-12 md:col-6">
          <div className="promoter-visual relative mx-auto">
            <img src={WorkWithUs} alt="Promotora usando um smartphone" className="w-full" />
            {cards.map((card) => (
              <div
                key={card.title}
                className={`promoter-card absolute border-round-lg text-white ${card.position}`}
              >
                <i className={card.icon} style={{ color: "var(--extra-mint)" }}></i>
                <div className="font-bold text-sm mt-2">{localeText(card.title)}</div>
                <div className="text-xs mt-1" style={{ color: "rgba(255,255,255,0.7)" }}>
                  {localeText(card.description)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingWorkWithUs;
